import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-date',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox [(ngModel)]="field.date_is_empty_by_default" binary="true"/>
        <label>{{ Yii.t('app', 'Date is empty by default') }}</label>
      </div>
    </div>
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox [(ngModel)]="field.to_show_he_il_calendar_in_rtl" binary="true"/>
        <label>{{ Yii.t('app', 'Use Hebrew Calendar') }}</label>
      </div>
    </div>
  `,
})
export class FieldDate {
  Yii = Yii;
  @Input() field: any;
}
